import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import FooterBar from 'components/FooterBar'
import ManageRooms from './ManageRooms'
import { RoomsContainer } from './styles'
import HotelOverview from './HotelOverview'
import moment from "moment-timezone";
import { TIME_ZONE } from "constants/constant";

const Cafe = () => {

  const [selectedDate, setSelectedDate] = useState(moment().tz(TIME_ZONE).format("YYYY-MM-DD"))
  console.log('selectedDate: ', selectedDate)
  return (
    <>
      <Helmet>
        <title>Cafe - Rook Hotel PMS</title>
        <meta name="description" content="Cafe - Rook Hotel PMS" />
      </Helmet>
      <RoomsContainer>
        <HotelOverview selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
        <ManageRooms selectedDate={selectedDate}/>
      </RoomsContainer>
      <FooterBar />
    </>
  );
};

export default Cafe;
